import GeneralStepper from "./GeneralStepper";
import {useSnackbar} from "notistack";
import useBusinessQueries from "../hooks/queries/useBusinessQueries";
import InvoiceData from "../pages/settings/components/InvoiceData";
import SubscriptionRenewal from "./SubscriptionRenewal";
import {Box, Typography} from "@mui/material";


const SubscriptionStepper = () => {
    const {businessGetBusinessQuery, updateBusinessMutation} = useBusinessQueries()
    const {data: business, isPending: businessLoading} = businessGetBusinessQuery
    const {enqueueSnackbar} = useSnackbar()

    const editBusiness = data => updateBusinessMutation.mutate({id: business.id, data: data}, {
        onSuccess: () => enqueueSnackbar('Mentve!', {variant: 'success'})
    })

    if (businessLoading) return null

    return <GeneralStepper steps={[
        {
            label: 'Számlázási adatok',
            component: <Box>
                <Typography variant='headline6' color='primary.600'>Számlázási adatok</Typography>
                <InvoiceData data={business} handleSubmit={data => editBusiness(data)}/>
            </Box>,
            validate: () => ({
                valid: !!business?.city,
                error: 'A továbblépéshez szükséges megadni és menteni a számlázási adatokat!'
            })
        },
        {
            label: 'Kártya adatok',
            component: <SubscriptionRenewal/>,
            validate: () => ({
                valid: false,
                error: 'Válassz, vagy adj hozzá egy kártyát az előfizetés megújításához!'
            })
        },
    ]} onFinish={() => enqueueSnackbar('Válassz, vagy adj hozzá egy kártyát az előfizetés megújításához!')}/>
}

export default SubscriptionStepper